"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PelmiSpolSRO = void 0;
exports.PelmiSpolSRO = {
    id: 'pelmiSpolSRO',
    companyName: 'Pelmi, spol. s r. o.',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'pelmiSpolSRO',
    },
    isInternal: false,
    isActive: true,
    countries: ['CZ'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGVsbWlTcG9sU1JPLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL1BlbG1pU3BvbFNSTy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLFlBQVksR0FBVTtJQUMvQixFQUFFLEVBQUUsY0FBYztJQUNsQixXQUFXLEVBQUUsc0JBQXNCO0lBQ25DLGNBQWMsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN2QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsY0FBYztLQUN4QjtJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==